import { ProjectModel } from '@/models';
import { OrderTaskModel } from './OrderTaskModel';

export class ProjectInfoModel {
  Project: ProjectModel;
  TotalWorkTime: number;
  Tasks: OrderTaskModel[];

  constructor(obj?: Partial<ProjectInfoModel>) {
    Object.assign(this, obj);
  }
}
